<rt-dialog-header
  [heading]="
    (containerDataSnapshot.isEdit
      ? 'app.wysiwyg.dialog.heading_edit'
      : 'app.wysiwyg.dialog.heading'
    ) | translate
  "
>
  <div class="subheading">
    {{ 'app.wysiwyg.dialog.subheading' | translate }}
  </div>
</rt-dialog-header>

<rt-dialog-body layout-vertical>
  <rt-form-field margin-bottom>
    <rt-label>{{ 'app.wysiwyg.dialog.link' | translate }}</rt-label>
    <rt-group variant="horizontal">
      <rt-input
        margin-right-small
        variant="readonly rounded"
        [formControl]="$any(form.get('link'))"
      >
      </rt-input>
      <rt-button *ngIf="isValidLink" variant="outline only-icon" (click)="linkOut()">
        <rt-icon name="open-in-new"></rt-icon>
      </rt-button>
    </rt-group>
    <div class="input-hint">
      {{ 'app.wysiwyg.dialog.link_subheading' | translate }}
    </div>
  </rt-form-field>

  <rt-form-field>
    <rt-label>{{ 'app.wysiwyg.dialog.text' | translate }}</rt-label>
    <rt-input
      [formControl]="$any(form.get('label'))"
      (keydown.enter)="submit()"
      [placeholder]="placeholder"
    ></rt-input>
  </rt-form-field>

  <div *ngIf="containerDataSnapshot.type === gdprConsentLinkType && !isDelayedEdit">
    <rt-divider variant="line large"></rt-divider>

    <rt-form-field>
      <rt-label>{{ 'app.wysiwyg.dialog.expiration' | translate }}</rt-label>
      <div layout-horizontal layout-centered-y>
        <rt-input
          [formControl]="$any(form.get('period'))"
          [maxWidth]="'190px'"
          type="number"
          (keydown.enter)="submit()"
          margin-right-small-x
        >
        </rt-input>
        {{ 'app.gdpr.days' | translate }}
      </div>
    </rt-form-field>
  </div>
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button
    *ngIf="containerDataSnapshot.isEdit"
    (click)="removeLink()"
    variant="outline"
    class="optional"
  >
    <rt-icon name="remove-circle"></rt-icon>
    {{ 'app.wysiwyg.dialog.remove_link' | translate }}
  </rt-button>

  <rt-button *ngIf="!loading" variant="plain" (click)="dialog.close()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" [disabled]="form.invalid" (click)="submit()">
    {{
      (containerDataSnapshot.isEdit
        ? 'app.common.save'
        : 'app.redactor_inserts.gdpr.dialog.insert_link'
      ) | translate
    }}
  </rt-button>
</rt-dialog-footer>
